import userApi from '@/request/apiList'
import router from '@/router/index'
import storage from 'store'

// import tinymce from 'tinymce/tinymce'
// import 'tinymce/skins/ui/oxide/skin.min.css'
// import 'tinymce/skins/content/default/content.css'
// import 'tinymce/skins/ui/oxide/content.min.css'
// import 'tinymce/themes/silver/theme.min.js'
// import 'tinymce/icons/default/icons.js'
// import 'tinymce/models/dom/model.js'
// import 'tinymce/plugins/autolink';
// import 'tinymce/plugins/directionality';
// import 'tinymce/plugins/preview';
// import 'tinymce/plugins/searchreplace';
// import 'tinymce/plugins/visualchars';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/visualblocks';
// import 'tinymce/plugins/codesample';
// import 'tinymce/plugins/fullscreen';
// import 'tinymce/plugins/table';
// import 'tinymce/plugins/media';
// import 'tinymce/plugins/nonbreaking';
// import 'tinymce/plugins/anchor';
// import 'tinymce/plugins/charmap';
// import 'tinymce/plugins/pagebreak';
// import 'tinymce/plugins/insertdatetime';
// import 'tinymce/plugins/advlist';
// import 'tinymce/plugins/wordcount';
// import 'tinymce/plugins/lists';
// import 'tinymce/plugins/emoticons';
// import 'tinymce/plugins/autosave';
// import 'tinymce/plugins/autoresize';
// require('./../plugins/image/index');

export default {
    //其他配置参数
    valid_elements: '*[*]', //表示允许所有HTML标签和属性
    extended_valid_elements: 'div[class|id]', //表示允许div标签和class、id属性
    allow_html_in_named_anchor: true, // 表示允许使用HTML代码作为锚点名称
    allow_script_urls: true, // 表示允许使用JavaScript脚本作为链接URL
    extended_valid_elements: "pre[*],script[*],style[*]",
    valid_children: '+body[style|script],pre[script|div|p|br|span|img|style|h1|h2|h3|h4|h5],*[*]',
    valid_elements : '*[*]',
    paste_data_images: true,// 设置为“true”将允许粘贴图像，而将其设置为“false”将不允许粘贴图像
    branding: false,    // 隐藏tinymce右下角水印
    powerpaste_word_import: 'merge', // 是否保留word粘贴样式  clean | merge
    // plugins:"fullpage",
    //皮肤
    skin: 'oxide',
    resize: true,
    //插件
    plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media code codesample table pagebreak nonbreaking anchor insertdatetime advlist lists wordcount autosave help',
    //工具栏
    toolbar:[
        'code undo redo bold italic underline strikethrough link forecolor backcolor fontsize fontfamily blocks',
        'alignleft aligncenter alignright outdent indent lineheight  bullist numlist blockquote subscript superscript removeformat table image fullscreen'],
    contextmenu: 'link image table bold italic underline strikethrough forecolor backcolor fontsize fontfamily block',
    //高度  因组件中存在autoresize故height不生效
    height: 500,
    font_family_formats: '宋体=\"宋体\"; 新宋体=\"新宋体\";仿宋_GB2312=\"仿宋_GB2312\"; 楷体_GB2312=\"楷体_GB2312\"; 黑体=\"黑体\"; 微软雅黑=\"微软雅黑\";Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Times New Roman=times new roman,times; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
    font_size_formats: '10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px',
    font_size_input_default_unit: "px",
    //图片上传
    images_upload_handler:(blobInfo, progress) => new Promise((resolve, reject) => {
        let { meeting_id } = router.currentRoute.params;
        var xhr, formData;
        var file = blobInfo.blob();//转化为易于理解的file对象
        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.upload.onprogress = (e) => {
            progress(e.loaded / e.total * 100);
        };
        xhr.open('POST',userApi.uploadImage);
        xhr.setRequestHeader('auth',storage.get('token'))
        xhr.setRequestHeader('meetingID',meeting_id)
        xhr.setRequestHeader('mid',meeting_id)
        xhr.onload = function() {
            var json;
            if (xhr.status != 200) {
                reject('HTTP Error: ' + xhr.status);
                return;
            }
            json = JSON.parse(xhr.responseText);
            if(json.code == 200){
                resolve(json.data.absolute_path);
            }else{
                reject('upload error');
            }
        };
        formData = new FormData();
        formData.append('file', file, file.name );//此处与源文档不一样
        xhr.send(formData);
    })
}